module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tooltip', _vm._b({
    ref: "tooltip",
    attrs: {
      "effect": _vm.effect,
      "placement": _vm.placement,
      "open-delay": _vm.openDelay,
      "popper-class": _vm.computedClass
    }
  }, 'el-tooltip', _vm.$attrs, false), [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70074157"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/tooltip/rtTooltip.vue
// module id = 2117
// module chunks = 228